var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
      name: 'IndustrialBranchDashboard',
      query: {
        branchId: _vm.data.branchID,
        companyId: this.$route.query.companyID
          ? this.$route.query.companyID
          : _vm.data.companyId,
      },
    }}},[_c('button',[_vm._v(_vm._s(_vm.$t("text.clickButtons.toDashboard")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }